import { WebSocketProvider } from "@/contexts/WebSocketConext";
import { useWebSocket } from "@/contexts/WebSocketConext";
import { BlockedScreen } from "@/pages/BlockedScreen";
import { isConfigured } from "@/services/config.services";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedContent = ({ children }: ProtectedRouteProps) => {
  const { isBlocked, isCheckingStatus } = useWebSocket();

  if (isCheckingStatus) {
    return null;
  }

  if (isBlocked) {
    return <BlockedScreen />;
  }

  return <>{children}</>;
};

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const configured = isConfigured();

  if (!configured) {
    return <Navigate to="/" replace />;
  }

  return (
    <WebSocketProvider>
      <ProtectedContent>{children}</ProtectedContent>
    </WebSocketProvider>
  );
};
